module.exports = "<app-externaluserhome *ngxPermissionsOnly=\"['Unknown']\"></app-externaluserhome>\r\n<app-internaluserhome *ngxPermissionsExcept=\"['Unknown']\" ></app-internaluserhome>"


//////////////////
// WEBPACK FOOTER
// ./src/app/home/home.component.html
// module id = ./src/app/home/home.component.html
// module chunks = main